module.exports = __webpack_public_path__ + "img/IMG_5615_P-2_L_Black_MockedUp.75c6a7a7.jpg";